import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GalleryService } from 'app/services/gallery/gallery.service';
import { ImageUrlPipe } from 'app/modules/admin/pipe/image-url.pipe';

@Component({
  selector: 'app-gallery-picker',
  standalone: true,
  imports: [CommonModule, ImageUrlPipe],
  templateUrl: './gallery-picker.component.html',
  styleUrls: ['./gallery-picker.component.scss']
})
export class GalleryPickerComponent implements OnInit {
  @Input() selectedImages: any[] = [];
  @Output() selectedImagesChange = new EventEmitter<any[]>();

  currentPath = '';
  folders: any[] = [];
  images: any[] = [];

  pageNumber = 1;
  pageSize = 20;
  totalPages = 1;

  loading = false;

  constructor(private galleryService: GalleryService) {}

  ngOnInit(): void {
    this.loadGallery();
  }

  loadGallery(): void {
  this.loading = true;

  this.galleryService.browse(this.currentPath, this.pageNumber, this.pageSize).subscribe({
    next: (res: any) => {
      console.log('Gallery Response:', res);

      this.currentPath = res.current_path === '.' ? '' : res.current_path;

      this.folders = res.folders || [];
      this.images = res.images || [];

      this.totalPages = res.meta?.total_pages || 1;
      this.pageNumber = res.meta?.page_number || 1;

      console.log('Folders:', this.folders);
      console.log('Images:', this.images);

      this.loading = false;
    },
    error: (err) => {
      console.error('Gallery load error:', err);
      this.folders = [];
      this.images = [];
      this.loading = false;
    }
  });
}

  openFolder(folder: any): void {
    this.currentPath = folder.path;
    this.pageNumber = 1;
    this.loadGallery();
  }

  goBack(): void {
    if (!this.currentPath) return;

    const parts = this.currentPath.split('/').filter(Boolean);
    parts.pop();

    this.currentPath = parts.join('/');
    this.pageNumber = 1;
    this.loadGallery();
  }

  toggleImage(image: any): void {
    const exists = this.isSelected(image);

    if (exists) {
      this.selectedImages = this.selectedImages.filter(x => x.path !== image.path);
    } else {
      this.selectedImages = [...this.selectedImages, image];
    }

    this.selectedImagesChange.emit(this.selectedImages);
  }

  isSelected(image: any): boolean {
    return this.selectedImages.some(x => x.path === image.path);
  }

  nextPage(): void {
    if (this.pageNumber >= this.totalPages) return;

    this.pageNumber++;
    this.loadGallery();
  }

  previousPage(): void {
    if (this.pageNumber <= 1) return;

    this.pageNumber--;
    this.loadGallery();
  }
}